import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertService, AuthenticationService, UserService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { PropertyConditionService } from '../property-condition.service';
import { PropertyCondition } from '../property-condition';
import { PropertyService } from '@app/_components/property/property.service';
import { User } from '@app/_models/user';

@Component({
    selector: 'app-property-condition',
    templateUrl: './property-condition.component.html',
    styleUrls: ['./property-condition.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class PropertyConditionComponent implements OnInit {
    categories: any;
    urgencies: any;
    rooms: any;
    reasons: any;
    outcomes: any;
    visibilities: any;
    users: any[]=[];
	properties: any[]=[];
	user: User;

	constructor(
		private primengConfig: PrimeNGConfig,
		private authenticationService: AuthenticationService,
		private propertyConditionService: PropertyConditionService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private userService: UserService,
		private formBuilder: FormBuilder,
		private propertyService: PropertyService,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.propertyCondition = data.propertyCondition,
			this.propertyConditionId = data?.propertyCondition?.propertyConditionId,
			this.statuses = propertyConditionService.statuses;
			this.categories = propertyConditionService.categories;
			this.urgencies = propertyConditionService.urgencies;
			this.rooms = propertyConditionService.rooms;
			this.reasons = propertyConditionService.reasons;
			this.outcomes = propertyConditionService.outcomes;
			this.visibilities = propertyConditionService.visibilities;
	}

	@Input() propertyCondition: PropertyCondition;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	propertyConditionId: number;

	// forms
	form1: FormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		'propertyConditionId': [{ type: 'required', message: 'Required' }],
		'category': [{ type: 'required', message: 'Required' }],
		'status': [{ type: 'required', message: 'Required' }],
		'urgency': [{ type: 'required', message: 'Required' }],
		'room': [{ type: 'required', message: 'Required' }],
		'description': [{ type: 'required', message: 'Required' }],
		'reason': [{ type: 'required', message: 'Required' }],
		'outcome': [{ type: 'required', message: 'Required' }],
		'costEst': [{ type: 'required', message: 'Required' }],
		'enteredByUserId': [{ type: 'required', message: 'Required' }],
		'visibility': [{ type: 'required', message: 'Required' }],
		'opsNotes': [{ type: 'required', message: 'Required' }],
		'shortTermRentalId':[{ type: 'required', message: 'Required' }],
		'maintenanceEventId':[{ type: 'required', message: 'Required' }]
	};

	ngOnInit() {
		this.fetchProperties();
		this.primengConfig.ripple = true;
		this.formBuild();
		// this.fetchUsers();
		// redirect to home if already logged in
		this.user = this.authenticationService.currentUserValue;
		// if we were passed the whole propertyCondition object
		if (this.propertyCondition) {
			this.fetchUsers(this.propertyCondition?.enteredByUserId);
			this.propertyConditionId = this.propertyCondition.propertyConditionId;
			this.fixDates();
			this.form1.patchValue(this.propertyCondition);
		}else{
			this.fetchUsers(this.user?.userId);
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.propertyConditionId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.propertyConditionService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.propertyCondition = res.data.propertyCondition;
						this.doAdd.emit(this.propertyCondition);
					},
					(err: any) => {
						console.log('propertyCondition-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('propertyCondition: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.propertyConditionService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.propertyCondition = res.data.propertyCondition;
						this.doUpdate.emit(this.propertyCondition);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.propertyConditionService.delete(this.propertyCondition.propertyConditionId)
				.subscribe(
					(res: any) => {
						console.log('propertyCondition-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.propertyCondition);
					},
					(err: any) => {
						console.log('propertyCondition-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			propertyConditionId: [this.propertyConditionId],
			category: ['', Validators.required],
			status: ['', Validators.required],
			urgency: ['', Validators.required],
			room: [],
			description: [],
			reason: ['', Validators.required],
			outcome: ['', Validators.required],
			costEst: [],
			enteredByUserId: [],
			visibility: [],
			opsNotes: [],
			shortTermRentalId:['', Validators.required],
			maintenanceEventId:[]
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.propertyCondition.propertyConditionDate = moment(this.propertyCondition.propertyConditionDate).toDate();
	}
	
	fetchUsers(userId: number) {
			try {
				this.userService.findById(userId)
					.subscribe(
						res => {
							// console.log('findAllusers: ' + JSON.stringify(res));
							this.users.push(res.data.user);
							this.form1.patchValue({
								enteredByUserId: userId
							});
							return this.users;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
	

	fetchProperties() {
		try {
			this.propertyService.propertySummaryForShortData()
				.subscribe(
					res => {
						// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
						this.properties = res.data.properties;
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}
}
